const backend = () => (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");

export const mediaSrc = (value = "") => {
  const url = String(value || "").trim();
  if (!url) return "";
  if (url.startsWith("/api/")) {
    const base = backend();
    return base ? `${base}${url}` : url;
  }
  return url;
};

export const storageMediaUrl = (value = "") => {
  const url = String(value || "").trim();
  if (!url) return "";
  const base = backend();
  if (base && url.startsWith(`${base}/api/`)) return url.slice(base.length);
  return url;
};

export const isDirectImageUrl = (url = "") => {
  const value = String(url || "").trim();
  if (!value) return false;
  if (value.startsWith("/api/media/")) return true;
  if (/^https?:\/\//i.test(value) && /\.(avif|gif|jpe?g|png|svg|webp)(?:[?#].*)?$/i.test(value)) return true;
  if (/images\.unsplash\.com|images\.pexels\.com/i.test(value)) return true;
  return false;
};

export const parseVideoEntry = (entry = "") => {
  if (entry && typeof entry === "object") {
    return {
      url: String(entry.url || entry.src || "").trim(),
      thumbnail: String(entry.thumbnail || entry.poster || "").trim(),
    };
  }
  const [rawUrl, ...rest] = String(entry || "").split("|");
  return {
    url: rawUrl.trim(),
    thumbnail: rest.join("|").trim(),
  };
};

export const youtubeId = (url = "") => {
  try {
    const u = new URL(url);
    if (u.hostname.includes("youtu.be")) return u.pathname.replace(/^\//, "").split("/")[0];
    if (u.hostname.includes("youtube.com")) {
      if (u.pathname.startsWith("/shorts/")) return u.pathname.split("/")[2];
      if (u.pathname.startsWith("/embed/")) return u.pathname.split("/")[2];
      return u.searchParams.get("v") || "";
    }
  } catch {}
  return "";
};

export const vimeoId = (url = "") => {
  try {
    const u = new URL(url);
    if (!u.hostname.includes("vimeo.com")) return "";
    return u.pathname.split("/").filter(Boolean).find((p) => /^\d+$/.test(p)) || "";
  } catch {}
  return "";
};

export const isVideoFile = (url = "") => /\.(mp4|webm|mov)(?:[?#].*)?$/i.test(url) || /^\/api\/media\//.test(url);

export const mediaIdFromUrl = (value = "") => {
  const normalized = storageMediaUrl(value);
  const m = normalized.match(/^\/api\/media\/([a-f0-9]{24})(?:[?#].*)?$/i);
  return m ? m[1] : "";
};
